import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { FooterWrapper, FooterSocialWrapper, FooterSocialIcons, P } from "../elements"

export const Footer = () => {
  const data = useStaticQuery(graphql`
    query {
      github: file(relativePath: {eq: "github1.png"}) {
        publicURL
      }
      linkedin: file(relativePath: {eq: "linkedin.png"}) {
        publicURL
      }
      twitter: file(relativePath: {eq: "twitter.png"}) {
        publicURL
      }
    }
  `)

  const thisYear = new Date().getFullYear();

  return (
    <FooterWrapper>
      <FooterSocialWrapper>
        <FooterSocialIcons>
          <a href="https://twitter.com/BarletzA52" target="_blank" rel="noopener noreferrer">
            <img src={data.twitter.publicURL} alt="twitter logo"/>
          </a>
          <a href="https://github.com/abrl91" target="_blank" rel="noopener noreferrer">
            <img src={data.github.publicURL} alt="github logo"/>
          </a>
          <a href="https://www.linkedin.com/in/amitbarletz/" target="_blank" rel="noopener noreferrer">
            <img src={data.linkedin.publicURL} alt="linkedin logo"/>
          </a>
        </FooterSocialIcons>
        <P size="xSmall" color="dark3">&copy; {thisYear} Amit Barletz</P>
      </FooterSocialWrapper>
    </FooterWrapper>
  )
}
